<template>
  <div class="start flex-grow-1 flex-fill">
    <div class="container-banned" v-if="htmlText"></div>
    <b-modal
      id="modal-banned"
      no-close-on-backdrop
      no-close-on-esc
      centered
      class="my-modal"
      data-bs-keyboard="false"
      hide-header
      size="xl"
      footer-bg-variant="light"
    >
      <b-container
        fluid="xl"
        style="max-height: 80vh !important; overflow-y: auto !important"
      >
        <div
          v-show="htmlText"
          v-html="$utils.convertMarkedOld(htmlText)"
          class="m-4"
        ></div>

        <div class="d-flex justify-content-between align-items-end m-2">
          <div class="custom-checkbox">
            <input
              type="checkbox"
              id="checkTerms"
              v-model="checkTerms"
              name="check"
            />
            <label
              class="form-check-label label-text"
              for="checkTerms"
              style="max-width: 490px"
            >
              <font class="m-4">
                <span>{{ $ml.get("youAgree") }} </span>
                <span>{{ $ml.get("ourLabel") }}</span>
                <a
                  href="https://bughunt.com.br/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ $ml.get("termsOfUse") }}
                </a>
                <span>{{ $ml.get("confirmReadOur") }} </span>
                <a
                  href="https://bughunt.com.br/code-of-conduct"
                  target="_blank"
                  rel="noopener noreferrer"
                  >{{ $ml.get("codeOfConduct") }}</a
                >
                {{ $ml.get("and") }}
                <a
                  href="https://bughunt.com.br/politica-de-privacidade.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  >{{ $ml.get("privacyPolicy") }}</a
                >.
              </font>
            </label>
          </div>
          <span style="font-size: 0.9rem"
            >{{ $ml.get("suspendedAccount") }}
            <strong>{{ initialDate }}</strong>
            {{ $ml.get("upTo").toLowerCase() }}
            <strong>{{ finalDate }}</strong></span
          >
        </div>
      </b-container>
      <template #modal-footer>
        <div class="w-100 float px-3">
          <b-button
            :disabled="!checkTerms"
            variant="primary"
            size="sm"
            class="float-right"
            @click="acceptTerms()"
            v-text="$ml.get('agree')"
          >
            Concordo
          </b-button>
        </div>
      </template>
    </b-modal>
    <Translate />
    <section class="row">
      <div class="col-4 px-3 py-5 d-none d-md-flex"></div>
      <div class="col-24 col-md-16 px-3 align-items-center d-flex">
        <div class="row align-itens-center">
          <div
            class="col-24 col-md-11 min-h text-right justify-content-start align-items-end d-flex flex-column pr-3"
          >
            <img src="../../assets/svg/logo.svg" class="align-self-end mb-2" />
            <h1
              class="title"
              v-text="$ml.get('yourSecurityPlatformAndBugReward')"
            >
              A sua plataforma de segurança e recompensa por bugs
            </h1>
            <p
              class="min-h d-none d-md-flex"
              v-text="$ml.get('youWillReceiveReportsFromCommunity')"
            >
              Você recebe feedbacks dos especialistas de segurança da nossa
              comunidade, sem custo adicional, enquanto minimiza as chances de
              expor suas vulnerabilidades na mídia ou redes sociais
            </p>
            <router-link
              class="btn btn-outline mb-3"
              to="/register"
              v-text="$ml.get('iWantToCreateAnAccount')"
            >
              Quero criar uma conta!
            </router-link>
            <p
              class="normal mt-4 d-none d-md-flex"
              v-text="$ml.get('doYouHaveOrganizationAndDidYou')"
            >
              Possui uma organização e gostou do projeto?
            </p>
            <p
              class="d-none d-md-flex"
              v-text="$ml.get('letStartYourRegistrationAnd')"
            >
              Vamos iniciar seu cadastro e logo um especialista irá entrar em
              contato com você para esclarecer as dúvidas e finalizar seu
              cadastro!
            </p>
            <router-link
              to="/company"
              class="btn btn-outline"
              v-text="$ml.get('startAnAccountForOrganization')"
            >
              Iniciar uma conta para organização!
            </router-link>
          </div>

          <div
            class="col-2 min-h d-none d-md-flex justify-content-center py-3 mb-5"
          >
            <span class="line align-self-center"></span>
          </div>

          <div
            v-if="!code2faEnable && !codeEmailEnable"
            class="col-24 col-md-11 min-h text-left justify-content-start align-items-end d-flex flex-column mt-5 pl-md-3"
          >
            <div class="card w-100">
              <div class="card-body">
                <h5 v-if="!authWithSSO" v-text="$ml.get('alreadyHaveAccount')">
                  Já possui uma conta?
                </h5>
                <h5 v-else>Entrar com login único</h5>
                <p v-text="$ml.get('thenUseYourEmail')" v-if="!authWithSSO">
                  Então utilize seu e-mail, sua senha e acesse nossa plataforma.
                  Caso tenha esquecido da senha ou seu usuário, utilize o
                  recuperar logo abaixo!
                </p>
                <p v-else v-text="$ml.get('ssoLoginMethodForOrganizations')">
                  Este método de login exclusivo para empresas que utilizam SSO
                  na BugHunt. Se você não faz parte de uma organização com SSO,
                  use a opção "Entrar sem SSO".
                </p>
                <form @submit="authUser" v-on:submit.prevent="">
                  <transition name="fade">
                    <div v-show="msgWarning" class="alert alert-warning">
                      <span
                        v-show="msgWarning == 'userBlock'"
                        v-text="$ml.get('userBlockedForOverTrying')"
                        >Usuário bloqueado por excesso de tentativas, tente
                        novamente mais tarde.</span
                      >
                      <span
                        v-show="msgWarning == 'errorLogin'"
                        v-text="$ml.get('invalidEmailOrPassword')"
                        >E-mail ou senha inválido!</span
                      >
                      <span v-show="msgWarning == 'blockedUser'"
                        >{{ $ml.get("userBlockedUntil") }} {{ dataBlocked }}
                        {{ $ml.get("toThe") }} {{ blockedUntilTime }}.</span
                      >
                      <span
                        v-show="msgWarning == 'sendEmail'"
                        v-text="$ml.get('aNewValidationEmailHasBeenSenToYou')"
                        >Um novo e-mail de validação foi enviado para você,
                        verique sua caixa postal</span
                      >
                      <span v-show="msgWarning == 'errorValidation'">
                        <font v-text="$ml.get('beforeContinuingYouNeed')"
                          >Antes de continuar é preciso validar seu
                          e-mail!</font
                        >
                        <br /><b v-text="$ml.get('attention')">Atenção:</b
                        >&nbsp;
                        <font
                          v-text="$ml.get('inSomeCasesTheEmailMayFallAsSpam')"
                          >Em alguns casos o e-mail pode cair no
                        </font>
                      </span>
                    </div>
                  </transition>

                  <transition name="fade">
                    <div v-show="msgSuccess" class="alert alert-success">
                      <font v-text="$ml.get('thanksForRegistering')"
                        >Obrigado por se cadastrar!</font
                      ><br />
                      <font v-text="$ml.get('weWillContactYouShortly')"
                        >Em breve entraremos em contato para confirmar seus
                        dados.
                      </font>
                    </div>
                  </transition>

                  <div class="row pb-1">
                    <div class="col">
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model.trim="user"
                          name="user"
                          placeholder="E-mail"
                          maxlength="50"
                          @input="accountNotFound = false"
                        />
                        <transition name="fade">
                          <label
                            v-if="userError && !$v.user.required"
                            class="lblError"
                            v-text="$ml.get('enterTheEmail')"
                          >
                            Digite o e-mail
                          </label>
                          <div class="mb-4" v-if="accountNotFound">
                            <label
                              class="lblError"
                              v-text="$ml.get('accountNotFound')"
                            >
                              O email que você inseriu não está conectado a uma
                              conta. Encontre sua conta e entre.
                            </label>
                          </div>
                        </transition>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="!authWithSSO">
                    <div class="col">
                      <div class="form-group">
                        <div style="display: flex">
                          <input
                            :type="showPassword ? 'text' : 'password'"
                            class="form-control"
                            v-model="password"
                            name="password"
                            :placeholder="$ml.get('yourAccessPassword')"
                            maxlength="200"
                          />
                          <VueCustomTooltip
                            :label="
                              $ml.get(
                                showPassword
                                  ? 'unshowPassword'
                                  : 'showPassword',
                              )
                            "
                            class="login-ico"
                            style="position: absolute"
                          >
                            <svg
                              class="ico-20"
                              @click="showPassword = !showPassword"
                            >
                              <image
                                v-show="showPassword"
                                xlink:href="../../assets/icons/eye-slash.svg"
                                width="20"
                                height="20"
                              />
                              <image
                                v-show="!showPassword"
                                xlink:href="../../assets/icons/eye.svg"
                                width="20"
                                height="20"
                              />
                            </svg>
                          </VueCustomTooltip>
                        </div>
                        <transition name="fade">
                          <label
                            v-if="userError && !$v.password.required"
                            class="lblError"
                            v-text="$ml.get('enterThePassword')"
                          >
                            Digite a senha
                          </label>
                        </transition>
                      </div>
                    </div>
                  </div>

                  <div
                    class="d-flex justify-content-center m-bottom"
                    style="margin-top: 5px"
                  >
                    <RecaptchaV2
                      ref="recaptcha"
                      @verify="setRecaptchToken"
                      @expired="tokenRecaptcha = ''"
                    />
                  </div>

                  <div class="row pt-2 m-bottom">
                    <!-- <button type="submit" :disabled="loadingBtn || !tokenRecaptcha" class="btn btn-lg btn-block"> -->
                    <button
                      type="submit"
                      :disabled="loadingBtn || !tokenRecaptcha"
                      class="btn btn-lg btn-block"
                    >
                      <Spinner v-show="loadingBtn" />
                      <span
                        v-show="!loadingBtn"
                        v-text="$ml.get('accessMyAccount')"
                        >Acessar minha conta!</span
                      >
                    </button>
                  </div>
                  <div class="m-bottom text-center" v-show="!authWithSSO">
                    <router-link
                      to="/forgot-password"
                      class="row d-flex justify-content-center align-items-center"
                      align="center"
                    >
                      <img
                        src="../../../src/assets/icons/lock-alt.svg"
                        class="ico-13 mx-2"
                      />
                      <span v-text="$ml.get('forgotYourPassword')">
                        Perdeu sua senha?
                      </span>
                    </router-link>
                  </div>
                  <div v-if="!authWithSSO" class="m-bottom c-sso">
                    <div class="d-sso col"></div>
                    <span>ou</span>
                    <div class="d-sso col"></div>
                  </div>
                  <div
                    v-if="!authWithSSO"
                    class="sso"
                    @click="authWithSSO = true"
                  >
                    <svg width="16" height="16" class="mr-2">
                      <image
                        xlink:href="../../assets/svg/globe-fill.svg"
                        width="16"
                        height="16"
                      />
                    </svg>
                    <span v-text="$ml.get('enterWithSSO')">Entrar com SSO</span>
                  </div>
                  <div
                    v-if="authWithSSO"
                    class="sso"
                    @click="authWithSSO = false"
                  >
                    <span v-text="$ml.get('enterWithoutSSO')"
                      >Entrar sem SSO</span
                    >
                  </div>
                </form>
              </div>
            </div>
          </div>

          <!-- Card 2fa -->
          <transition name="fade">
            <div
              class="col-24 col-md-10 min-h text-left justify-content-start align-items-end d-flex flex-column mt-5 pl-md-3"
            >
              <div v-if="code2faEnable || codeEmailEnable" class="card w-100">
                <div class="card-body">
                  <h5 v-text="$ml.get('accessValidation')">
                    Validação de acesso
                  </h5>
                  <p>
                    Utilize o código de verificação para garantir a segurança do
                    seu acesso.
                  </p>
                  <form @submit="authUser" v-on:submit.prevent="">
                    <div v-if="code2faEnable">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <label
                              v-text="
                                $ml.get(
                                  'useYourAuthenticationAppToEnterTheCode',
                                )
                              "
                            >
                              Use seu aplicativo de autenticação para inserir o
                              código</label
                            >
                            <the-mask
                              class="form-control"
                              v-model="code2fa"
                              :mask="['### ###']"
                              :placeholder="$ml.get('enterTheCode')"
                            />
                            <transition name="fade">
                              <label
                                v-if="errorCode2fa"
                                class="lblError"
                                v-text="$ml.get('invalidBackupCodeOrToken')"
                              >
                                Código ou token de backup inválidos
                              </label>
                            </transition>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="codeEmailEnable" class="row">
                      <div class="col">
                        <div class="form-group">
                          <label>Use o código recebido por email</label>
                          <the-mask
                            class="form-control"
                            v-model="codeEmail"
                            :mask="['### ###']"
                            :placeholder="$ml.get('enterTheCode')"
                          />
                          <transition name="fade">
                            <label
                              v-if="errorCodeEmail"
                              class="lblError"
                              v-text="$ml.get('invalidCodeError')"
                            >
                              O código informado não é válido!
                            </label>
                          </transition>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-center mb-2">
                      <RecaptchaV2
                        ref="recaptcha"
                        @verify="setRecaptchToken"
                        @expired="tokenRecaptcha = ''"
                      />
                    </div>
                    <div class="row pt-2">
                      <button
                        v-if="enabled2fa && !enabledEmailCode"
                        type="submit"
                        :disabled="loadingBtn || !code2fa || !tokenRecaptcha"
                        class="btn btn-lg btn-block"
                      >
                        <Spinner v-show="loadingBtn" />
                        <span v-show="!loadingBtn" v-text="$ml.get('toCheck')"
                          >Verificar</span
                        >
                      </button>
                      <button
                        v-if="!enabled2fa && enabledEmailCode"
                        type="submit"
                        :disabled="loadingBtn || !codeEmail || !tokenRecaptcha"
                        class="btn btn-lg btn-block"
                      >
                        <Spinner v-show="loadingBtn" />
                        <span v-show="!loadingBtn" v-text="$ml.get('toCheck')"
                          >Verificar</span
                        >
                      </button>
                      <button
                        v-if="enabled2fa && enabledEmailCode"
                        type="submit"
                        :disabled="
                          loadingBtn ||
                          !code2fa ||
                          !codeEmail ||
                          !tokenRecaptcha
                        "
                        class="btn btn-lg btn-block"
                      >
                        <Spinner v-show="loadingBtn" />
                        <span v-show="!loadingBtn" v-text="$ml.get('toCheck')"
                          >Verificar</span
                        >
                      </button>
                    </div>

                    <div v-if="code2faEnable" class="mt-3 pointer">
                      <a
                        class="mx-2 text-left"
                        @click="validateTokenBackup()"
                        v-text="$ml.get('useBackupCode')"
                        >Usar código de backup ?</a
                      >
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </section>
    <ModalBackup2FA
      ref="modalBack2FA"
      :user="user"
      v-model="showModalBackup2FA"
      @sendRequest="sendTokenBackup"
      @update:setRecaptchaToken="setRecaptchaToken"
      @update:codeInput="updateCodeInput"
      @update:codeEmail="updateCodeEmail"
    />
  </div>
</template>

<script>
import axios from "axios";
import axiosConfigs from "../../HTTP";
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import RecaptchaV2 from "../../components/recaptchaV2.vue";
import Translate from "../../components/translate.vue";
import ModalBackup2FA from "../../components/auth/ModalBackup2FA.vue";
export default {
  components: {
    RecaptchaV2,
    Translate,
    ModalBackup2FA,
  },
  page: {
    title: "Login",
    meta: [{ name: "description" }],
  },
  data() {
    return {
      user: "",
      password: "",
      inputPassword: "password",
      showPassword: false,
      loadingBtn: false,
      msgSuccess: false,
      msgWarning: false,
      userError: false,
      passError: false,
      passwordTooltipMessage: "showPassword",
      errorCode2fa: false,
      code2fa: "",
      codeEmail: "",
      recoveryKey: "",
      code2faEnable: false,
      codeEmailEnable: false,
      errorCodeEmail: false,
      enabled2fa: false,
      enabledEmailCode: false,
      tokenRecaptcha: "",
      dataBlocked: "",
      blockedUntilTime: "",
      authWithSSO: false,
      accountNotFound: false,
      showModalBackup2FA: false,
      checkTerms: "",
      htmlText: "",
      initialDate: "",
      finalDate: "",
    };
  },
  validations: {
    user: { required },
    password: { required },
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  watch: {
    authWithSSO() {
      localStorage.setItem("login-option", this.authWithSSO);
    },
  },
  mounted() {
    this.user = this.$route.params?.email;
    this.$v.$reset();

    this.authWithSSO = JSON.parse(localStorage.getItem("login-option"));
  },
  methods: {
    ...mapActions([
      "setUser",
      "resetUser",
      "setAmountPrograms",
      "setCanAccessExtApi",
      "setTermsUseConduct",
      "setAmountPentests"
    ]),

    updateCodeEmail(value) {
      this.codeEmail = value;
    },

    updateCodeInput(value) {
      this.recoveryKey = value;
    },

    sendTokenBackup() {
      this.authUser();
    },

    validateTokenBackup() {
      this.showModalBackup2FA = true;
    },

    setRecaptchaToken(token) {
      this.tokenRecaptcha = token;
    },

    setRecaptchToken(token) {
      this.tokenRecaptcha = token;
    },

    resetCaptcha() {
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.loadRecaptchaScript();
      }
    },

    async authSSO() {
      var self = this;
      this.loadingBtn = true;
      this.accountNotFound = false;
      try {
        const { data, status } = await axios.post(
          this.$apiUrlAuth + `sso/get-idp-url`,
          {
            email: this.user,
            tokenRecaptcha: this.tokenRecaptcha,
          },
        );
        if (status == 201) {
          this.redirectPage(data);
        }
        self.loadingBtn = false;
      } catch (error) {
        self.$refs.recaptcha.resetRecaptcha();
        self.tokenRecaptcha = "";
        self.loadingBtn = false;
        this.accountNotFound = true;
      }
    },

    redirectPage(uri) {
      if (uri) {
        window.location.href = uri;
        return;
      }
      console.log("IDP: Não encontrado!");
    },

    authUser() {
      if (this.authWithSSO) {
        this.authSSO();
        return;
      }
      var self = this;
      this.msgSuccess = false;
      this.msgWarning = false;
      this.userError = false;
      this.passError = false;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.userError = true;

        this.resetCaptcha();
        return;
      }

      this.loadingBtn = true;
      this.errorCode2fa = false;
      this.errorCodeEmail = false;
      this.resetUser();
      delete axios.defaults.headers.common["Authorization"];

      let code2fa = {
        code: this.code2fa,
        recoveryKey: this.recoveryKey,
      };

      if (!this.code2fa) {
        delete code2fa.code;
      }

      if (!this.recoveryKey) {
        delete code2fa.recoveryKey;
      }

      let codeEmail = {
        email_token: Number(this.codeEmail),
      };

      if (!this.codeEmail) {
        delete codeEmail.email_token;
      }

      if (self.showModalBackup2FA) {
        self.$refs.modalBack2FA.errorCodeBackup = false;
        self.$refs.modalBack2FA.errorCodeEmail = false;
      }

      axios
        .post(this.$apiUrlAuth + `login`, {
          username: this.user,
          password: this.password,
          tokenRecaptcha: this.tokenRecaptcha,
          ...code2fa,
          ...codeEmail,
        })
        .then(async (response) => {
          if (response.data === "Codigo enviado para o email!") {
            self.loadingBtn = false;

            self.codeEmailEnable = true;
            return;
          }

          var decodedStr = JSON.parse(
            atob(response.data.access_token.split(".")[1]),
          );

          this.setTermsUseConduct(decodedStr.termsUseConduct);

          if (
            decodedStr.status == "email_validation" &&
            decodedStr.roles[0] == "hacker"
          ) {
            self.loadingBtn = false;
            self.msgWarning = "errorValidation";
            return;
          }
          if (
            decodedStr.status == "pending" &&
            decodedStr.roles[0] == "company"
          ) {
            self.loadingBtn = false;
            self.msgSuccess = true;
            return;
          }
          await localStorage.setItem("token", response.data.access_token);
          await axiosConfigs(response.data.access_token);
          await self.getDados(response.data.access_token, decodedStr.roles[0]);
        })
        .catch(function (error) {
          self.$refs.recaptcha.resetRecaptcha();
          self.tokenRecaptcha = "";
          self.loadingBtn = false;

          const errorUserBlocked = error.response.data.message
            .slice(0, 12)
            .trim();
          self.dataBlocked = self.$utils.formatDataShort(
            error.response.data.message.slice(18, 50).trim(),
          );
          self.blockedUntilTime = error.response.data.message
            .slice(35, 44)
            .trim();
          if (errorUserBlocked === "User blocked") {
            self.msgWarning = "blockedUser";
            return;
          }
          if (error.response.data.message === "Unauthorized") {
            self.msgWarning = "errorLogin";
            self.loadingBtn = false;
            return;
          }

          if (
            error.response.data.message ==
            "O codigo do autenticador não é válido!"
          ) {
            if (self.showModalBackup2FA) {
              self.$refs.modalBack2FA.errorCodeBackup = true;
              self.loadingBtn = false;
              return;
            }

            self.loadingBtn = false;

            if (self.code2faEnable) {
              self.errorCode2fa = true;
              // self.code2fa = "";
            }
            self.code2faEnable = true;
            return;
          }

          try {
            const {
              enabled2fa,
              enabledEmailCode,
              is2faCodeValid,
              isEmailCodeValid,
            } = JSON.parse(error?.response?.data?.message);

            self.enabled2fa = enabled2fa;
            self.enabledEmailCode = enabledEmailCode;

            if (enabled2fa && enabledEmailCode) {
              self.loadingBtn = false;
              self.codeEmailEnable = true;
              self.code2faEnable = true;
            }
            if (enabled2fa) {
              self.loadingBtn = false;
              self.code2faEnable = true;
            }
            if (enabledEmailCode) {
              self.loadingBtn = false;
              self.codeEmailEnable = true;
            }

            if (self.code2fa && !is2faCodeValid) {
              self.code2faEnable = true;
              if (self.code2faEnable) {
                self.errorCode2fa = true;
                // self.code2fa = "";
                return;
              }
            }
            if (self.codeEmail && !isEmailCodeValid) {
              self.codeEmailEnable = true;
              if (self.codeEmailEnable) {
                self.errorCodeEmail = true;
                self.codeEmail = "";
                return;
              }
            }
          } catch (error) {
            console.log(error);
          }
          if (
            error.response.data.message ==
            "O codigo enviado para o email deve ser informado!"
          ) {
            self.loadingBtn = false;
            self.codeEmailEnable = true;
            return;
          }
          if (error.response.data.message == "O token do email não é válido!") {
            if (self.showModalBackup2FA) {
              self.$refs.modalBack2FA.errorCodeEmail = true;
              self.loadingBtn = false;
              return;
            }

            self.codeEmailEnable = true;
            if (self.codeEmailEnable) {
              self.errorCodeEmail = true;
              self.codeEmail = "";
            }
            return;
          }
          if (
            error.response.data.message == "Verification email already sent!"
          ) {
            self.loadingBtn = false;
            self.msgWarning = "errorValidation";
            return;
          }

          if (error.response.data.message == "Account is not active!") {
            self.loadingBtn = false;
            self.msgWarning = "sendEmail";
            return;
          }

          if (error.response.data.message.match(/User blocked until/)) {
            self.loadingBtn = false;
            self.msgWarning = "userBlock";
            return;
          }
          self.msgWarning = "errorLogin";
        });
    },

    async getDados(token, type) {
      var self = this;

      axios
        .get(this.$store.getters["getApiUrl"] + `account/my`)
        .then(async (response) => {
          self.setUser({
            token: token,
            type: type,
            account_avatar: response.data.account_avatar,
            company_avatar: response.data?.company_avatar,
            name: response.data.name,
            email: response.data.email,
            companyName: response.data?.companyName,
            username: response.data?.username,
            verified: response.data?.verified,
            paypal_account: response.data?.paypal_account,
            amount_of_reports: response.data?.amount_of_reports,
            score: response.data?.score,
            role: response.data?.role,
            plan: response.data.plan,
            company_createdAt: response.data.company_createdAt,
            account_createdAt: response.data.account_createdAt,
            two_factor_auth_login: response.data.two_factor_auth_login,
            email_code_required: response.data.email_code_required,
            lockerPassword: response.data.lockerPassword,
          });
          if (type == "company") {
            self.setAmountPrograms(response.data.amount_of_programs);
            self.setCanAccessExtApi(response.data.plan.can_access_ext_api);
            self.setAmountPentests(response.data.amount_of_pentests);

            self.setUser({
              two_factor_auth_required:
                response.data.settings.two_factor_auth_required,
              currency: response.data.settings.currency,
              lockerSettings: response.data.lockerSettings,
            });
            const two_factor_auth_required =
              response.data.settings.two_factor_auth_required;
            const two_factor_auth_login = response.data.two_factor_auth_login;
            if (two_factor_auth_required && !two_factor_auth_login) {
              this.$router.push({
                name: "account",
                params: { authentication: "authentication" },
              });
              return;
            }
          }
          if (type == "hacker") {
            self.setUser({
              pending_invitations: response.data.pending_invitations,
            });
          }

          if(this.$store.getters['getProgramWithout']){
            window.location.replace("/dashboard");
            this.$store.dispatch("setRouteTo", "");
            return;
          }
          
          if (this.$store.getters["getRouteTo"]) {
            let to = this.$store.getters["getRouteTo"];
            this.$store.dispatch("setRouteTo", "");
            window.location.replace(to);
            return;
          }

          window.location.replace("/dashboard");
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.isSuspended) {
            self.htmlText = error.response.data.message;
            self.initialDate = self.$utils.formatDataShort(
              error.response.data.initial_date,
            );
            self.finalDate = self.$utils.formatDataShort(
              error.response.data.final_date,
            );
            self.loadingBtn = false;

            self.$bvModal.show("modal-banned");
            return;
          }
        });
    },

    useBackupCode() {
      var self = this;
      Swal.fire({
        html: `<h5 class="mb-3">Two-factor authentication <h5
              <br>
              <label>
                  ${self.$ml.get("typeOrPasteOneOfYourBackupTokens")}
              </label> `,
        input: "text",
        customClass: "swal-2fa",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: self.$ml.get("send"),
        cancelButtonText: self.$ml.get("cancel"),
        confirmButtonColor: "#730BA9",
        showLoaderOnConfirm: true,
        preConfirm: (backup) => {
          self.recoveryKey = backup;
          self.executeRecaptcha();
        },

        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (!result.isConfirmed) {
          self.loadingBtn = false;
        }
      });
    },
    async acceptTerms() {
      const api = process.env.VUE_APP_APIURL;
      try {
        const { status } = await axios.post(api + `account/verify-suspension`);

        if (status === 201) {
          Swal.fire({
            icon: "success",
            title:  this.$ml.get('termsAcceptWithSuccess'),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2500,
          });

          this.checkTerms = false;
          this.$refs.recaptcha.resetRecaptcha();
          this.tokenRecaptcha = "";
        }

        this.$bvModal.hide("modal-banned");
        this.htmlText = "";
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss">
.title {
  font-size: 3vh !important;
}

.login-ico {
  position: absolute;
  right: 7px;
  top: 15%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.lblError {
  font-size: 11px;
  padding-left: 5px;
  color: red;
  margin: 0;
  position: absolute;
}

.swal-2fa {
  width: 24em !important;
  padding: 0.5em !important;
  padding-top: 1em !important;
  border-radius: 5px;

  .swal2-input {
    height: 2.25em !important;
    padding: 0 0.55em !important;
    font-size: 0.9em !important;
  }

  .swal2-actions {
    margin: 0.2em auto 1em;
    padding: 0 1.6em;
  }
}
.c-sso {
  display: flex;
  align-items: center;
  gap: 10px;
}
.c-sso > span {
  margin-bottom: 5px;
  font-size: 18px;
  color: #747474;
}
.d-sso {
  height: 1px;
  background: #cacaca;
}
.sso {
  width: 100%;
  padding: 15px;
  box-shadow: 0px 0px 2px 1px #ccccccb5;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 400;
  transition: all 300ms;
}
.sso:hover {
  background: #cccccc36;
}
.m-top {
  margin-top: 1rem;
}
.m-bottom {
  margin-bottom: 1rem;
}

.container-banned {
  position: absolute;
  z-index: 200;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #000000b3;
}

.modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: 1200px;
  transform: translate(-50%, -50%);
  z-index: 300;
}
.comp-translate {
  z-index: 100 !important;
}

/*Custom checkboxes style*/
.custom-checkbox input[type="checkbox"] + .label-text:before {
  content: "";
  text-transform: none;
  line-height: 0.8;
  display: inline-block;
  border-radius: 3px;
  border: #730ca8 1px solid;
  padding: 7px;
  position: absolute;
}
.custom-checkbox input[type="checkbox"]:checked + .label-text:before {
  content: "✓";
  color: #730ca8;
  border: #730ca8 1px solid;
  animation: effect 250ms ease-in;
  padding: 1px;
}
.btn-primary.disabled,
.btn-primary:disabled {
  color: #fff;
  background-color: #717171;
  border-color: #d8d8d8;
}
</style>
